module.exports = __webpack_public_path__ + "img/gallery-cookie-closed.6616bf0e.webp";